const canvas = document.createElement('canvas');
const context = canvas.getContext('2d');
export function measureText(text, fontSizeOrVariant) {
    const fontSize = (() => {
        if (typeof fontSizeOrVariant === 'number') {
            return fontSizeOrVariant;
        }
        switch (fontSizeOrVariant) {
            case 'h1':
                return 96;
            case 'h2':
                return 60;
            case 'h3':
                return 48;
            case 'h4':
                return 34;
            case 'h5':
                return 24;
            case 'h6':
                return 20;
            case 'subtitle1':
                return 16;
            case 'subtitle2':
                return 14;
            case 'body1':
                return 16;
            case 'body2':
                return 14;
            case 'caption':
                return 12;
            case 'button':
                return 14;
            case 'overline':
                return 12;
            default:
                return 16;
        }
    })();
    if (context) {
        context.font = `${fontSize}px Roboto`;
        return Math.ceil(context.measureText(text).width);
    }
    return 0;
}
